"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFormattedText(text) {
    const result = [];
    if (!text) {
        return result;
    }
    const formatCodes = {
        '*1': 'copy-white',
    };
    text.split('*').forEach((word, index) => {
        if (index === 0) {
            return;
        }
        const formatCode = word.substring(0, 1);
        const classNameTitle = formatCodes[`*${formatCode}`];
        const text = formatCode !== ' ' ? word.substring(1) : word;
        result.push({
            text,
            classNameTitle,
        });
    });
    return result;
}
exports.default = getFormattedText;
